import { render, staticRenderFns } from "./ComplianceFinanceTab.vue?vue&type=template&id=a05fbf8e&"
import script from "./ComplianceFinanceTab.vue?vue&type=script&lang=js&"
export * from "./ComplianceFinanceTab.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFinanceTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResendDocusignEnvelopeDialog: require('/codebuild/output/src2428694706/src/cc-portal/components/ResendDocusignEnvelopeDialog.vue').default})
